import { createGlobalStyle } from 'styled-components';
import { ThemeType } from '../../modules/style/theme';

export const StyledProvablyFairGlobal = createGlobalStyle<{ theme: ThemeType }>`
	.page-provablyFair {
		.settings__panel {
			&--overview,
			&--implementation {
				font-family: ${(props) => props.theme.text.fonts.Regular};
				line-height: ${(props) => props.theme.text.height.regular};
			}
		}
	}
`;
